import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import Pillars from "../components/Pillars";
import FirstThreeDays from "../components/FirstThreeDays";
import FounderStory from "../components/FounderStory";
import ChallengeBlock from "../components/ChallengeBlock";
import Problem from "../components/Problem";
import PrivacyTrust from "../components/PrivacyTrust";
import Pricing from "../components/Pricing";
import WhyNumbers from "../components/WhyNumbers";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import FAQSection from "../components/FAQSection";
import StickyCTA from "../components/StickyCTA";
import { track } from "../lib/analytics";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Ascend Higher — Turn your scattered life into a daily roadmap";
    track("landing_view");
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref) {
        sessionStorage.setItem("ascend_ref_code", ref);
        track("referral_link_landed", { code: ref });
      }
      const utm = ["utm_source", "utm_medium", "utm_campaign", "utm_content"]
        .map((k) => [k, params.get(k)])
        .filter(([, v]) => v);
      if (utm.length) {
        sessionStorage.setItem("ascend_utm", JSON.stringify(Object.fromEntries(utm)));
        track("utm_captured", Object.fromEntries(utm));
      }
    } catch (e) {}
  }, []);
  return (
    <div className="min-h-screen bg-[#f7f3ea]">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Pillars />
        <FirstThreeDays />
        <FounderStory />
        <ChallengeBlock />
        <Problem />
        <PrivacyTrust />
        <Pricing />
        <WhyNumbers />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
